import { render, staticRenderFns } from "./LatestUpdatesCauser.vue?vue&type=template&id=981684f4&"
import script from "./LatestUpdatesCauser.vue?vue&type=script&lang=js&"
export * from "./LatestUpdatesCauser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports